import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import { Link } from "react-router-dom";
import { TEAM_MEMBERS } from "../../constants/TeamConstant";

const Team = () => {
  return (
    <div className="home3-team-area">
      <div className="container">
        {/* Section Title */}
        <div
          className="row mb-55 wow animate__animated animate__fadeInUp"
          data-wow-delay="200ms"
          data-wow-duration="1500ms"
        >
          <div className="col-lg-12 d-flex align-items-center justify-content-between flex-wrap gap-4">
            <div className="section-title-3">
              <h2>Team Members</h2>
              <p>
                Our team is a blend of creative thinkers, skilled engineers, and
                problem-solvers dedicated to turning ideas into powerful digital
                solutions.
              </p>
            </div>
            <div className="view-all-btn">
              <Link className="primary-btn3" to="/teams">
                View All Team
              </Link>
            </div>
          </div>
        </div>

        {/* Team Slider */}
        <div className="row">
          <div className="col-lg-12">
            <Swiper
              className="home3-team-slider"
              modules={[Autoplay, Pagination]}
              loop={true}
              speed={1500}
              effect="fade"
              fadeEffect={{
                crossFade: true,
              }}
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
              }}
              spaceBetween={30}
              slidesPerView={4}
              pagination={{
                clickable: true,
                el: ".swiper-pagination11", // custom pagination element
              }}
              breakpoints={{
                0: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 4 },
              }}
            >
              {TEAM_MEMBERS.map(({ name, role, image, socialLinks }) => (
                <SwiperSlide key={role}>
                  <div key={name} className="swiper-slide">
                    <div className="single-team">
                      <div className="team-img">
                        <img className="img-fluid" src={image} alt={name} />
                        <div className="social-area">
                          <ul>
                            {socialLinks.map(({ icon, url }) => (
                              <li key={url}>
                                <Link
                                  to={url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <i className={icon}></i>
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                      <div className="team-content">
                        <h5> {name} </h5>
                        <span> {role} </span>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            <div className="row pt-30">
              <div className="col-lg-12 position-relative">
                <div className="swiper-pagination11"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Team;
